import proj4 from "proj4";

const PROFILE_KEY = "hydrotools:projection-profile:v1";
const CUSTOM_CRS_KEY = "hydrotools:projection-custom:v1";

const BUILTIN_CRS = [
  { code: "EPSG:4326", name: "WGS 84 (Lat/Lon)", proj4: "+proj=longlat +datum=WGS84 +no_defs +type=crs" },
  { code: "EPSG:3857", name: "Web Mercator", proj4: "+proj=merc +a=6378137 +b=6378137 +lat_ts=0 +lon_0=0 +x_0=0 +y_0=0 +k=1 +units=m +nadgrids=@null +wktext +no_defs +type=crs" },
  { code: "EPSG:2273", name: "NAD83 / South Carolina (US-ft)", proj4: "+proj=lcc +lat_0=31.8333333333333 +lon_0=-81 +lat_1=34.8333333333333 +lat_2=32.5 +x_0=609600 +y_0=0 +ellps=GRS80 +datum=NAD83 +units=us-ft +no_defs +type=crs" },
  { code: "EPSG:32610", name: "WGS 84 / UTM zone 10N", proj4: "+proj=utm +zone=10 +datum=WGS84 +units=m +no_defs +type=crs" },
  { code: "EPSG:32611", name: "WGS 84 / UTM zone 11N", proj4: "+proj=utm +zone=11 +datum=WGS84 +units=m +no_defs +type=crs" },
  { code: "EPSG:32612", name: "WGS 84 / UTM zone 12N", proj4: "+proj=utm +zone=12 +datum=WGS84 +units=m +no_defs +type=crs" },
  { code: "EPSG:32613", name: "WGS 84 / UTM zone 13N", proj4: "+proj=utm +zone=13 +datum=WGS84 +units=m +no_defs +type=crs" },
  { code: "EPSG:32614", name: "WGS 84 / UTM zone 14N", proj4: "+proj=utm +zone=14 +datum=WGS84 +units=m +no_defs +type=crs" },
  { code: "EPSG:32615", name: "WGS 84 / UTM zone 15N", proj4: "+proj=utm +zone=15 +datum=WGS84 +units=m +no_defs +type=crs" },
  { code: "EPSG:32616", name: "WGS 84 / UTM zone 16N", proj4: "+proj=utm +zone=16 +datum=WGS84 +units=m +no_defs +type=crs" },
  { code: "EPSG:32617", name: "WGS 84 / UTM zone 17N", proj4: "+proj=utm +zone=17 +datum=WGS84 +units=m +no_defs +type=crs" },
  { code: "EPSG:32618", name: "WGS 84 / UTM zone 18N", proj4: "+proj=utm +zone=18 +datum=WGS84 +units=m +no_defs +type=crs" },
  { code: "EPSG:32619", name: "WGS 84 / UTM zone 19N", proj4: "+proj=utm +zone=19 +datum=WGS84 +units=m +no_defs +type=crs" },
  { code: "EPSG:32620", name: "WGS 84 / UTM zone 20N", proj4: "+proj=utm +zone=20 +datum=WGS84 +units=m +no_defs +type=crs" },
  { code: "EPSG:26910", name: "NAD83 / UTM zone 10N", proj4: "+proj=utm +zone=10 +datum=NAD83 +units=m +no_defs +type=crs" },
  { code: "EPSG:26911", name: "NAD83 / UTM zone 11N", proj4: "+proj=utm +zone=11 +datum=NAD83 +units=m +no_defs +type=crs" },
  { code: "EPSG:26912", name: "NAD83 / UTM zone 12N", proj4: "+proj=utm +zone=12 +datum=NAD83 +units=m +no_defs +type=crs" },
  { code: "EPSG:26913", name: "NAD83 / UTM zone 13N", proj4: "+proj=utm +zone=13 +datum=NAD83 +units=m +no_defs +type=crs" },
  { code: "EPSG:26914", name: "NAD83 / UTM zone 14N", proj4: "+proj=utm +zone=14 +datum=NAD83 +units=m +no_defs +type=crs" },
  { code: "EPSG:26915", name: "NAD83 / UTM zone 15N", proj4: "+proj=utm +zone=15 +datum=NAD83 +units=m +no_defs +type=crs" },
  { code: "EPSG:26916", name: "NAD83 / UTM zone 16N", proj4: "+proj=utm +zone=16 +datum=NAD83 +units=m +no_defs +type=crs" },
  { code: "EPSG:26917", name: "NAD83 / UTM zone 17N", proj4: "+proj=utm +zone=17 +datum=NAD83 +units=m +no_defs +type=crs" },
  { code: "EPSG:26918", name: "NAD83 / UTM zone 18N", proj4: "+proj=utm +zone=18 +datum=NAD83 +units=m +no_defs +type=crs" },
  { code: "EPSG:26919", name: "NAD83 / UTM zone 19N", proj4: "+proj=utm +zone=19 +datum=NAD83 +units=m +no_defs +type=crs" },
  { code: "EPSG:26920", name: "NAD83 / UTM zone 20N", proj4: "+proj=utm +zone=20 +datum=NAD83 +units=m +no_defs +type=crs" },
  { code: "EPSG:26941", name: "NAD83 / California zone 1 (m)", proj4: "+proj=lcc +lat_0=39.3333333333333 +lon_0=-122 +lat_1=40 +lat_2=41.6666666666667 +x_0=2000000 +y_0=500000 +ellps=GRS80 +datum=NAD83 +units=m +no_defs +type=crs" },
  { code: "EPSG:26942", name: "NAD83 / California zone 2 (m)", proj4: "+proj=lcc +lat_0=37.6666666666667 +lon_0=-122 +lat_1=38.3333333333333 +lat_2=39.8333333333333 +x_0=2000000 +y_0=500000 +ellps=GRS80 +datum=NAD83 +units=m +no_defs +type=crs" },
  { code: "EPSG:26943", name: "NAD83 / California zone 3 (m)", proj4: "+proj=lcc +lat_0=36.5 +lon_0=-120.5 +lat_1=37.0666666666667 +lat_2=38.4333333333333 +x_0=2000000 +y_0=500000 +ellps=GRS80 +datum=NAD83 +units=m +no_defs +type=crs" },
  { code: "EPSG:26944", name: "NAD83 / California zone 4 (m)", proj4: "+proj=lcc +lat_0=35.3333333333333 +lon_0=-119 +lat_1=36 +lat_2=37.25 +x_0=2000000 +y_0=500000 +ellps=GRS80 +datum=NAD83 +units=m +no_defs +type=crs" },
  { code: "EPSG:26945", name: "NAD83 / California zone 5 (m)", proj4: "+proj=lcc +lat_0=34 +lon_0=-118 +lat_1=34.0333333333333 +lat_2=35.4666666666667 +x_0=2000000 +y_0=500000 +ellps=GRS80 +datum=NAD83 +units=m +no_defs +type=crs" },
  { code: "EPSG:26946", name: "NAD83 / California zone 6 (m)", proj4: "+proj=lcc +lat_0=32.1666666666667 +lon_0=-116.25 +lat_1=33.8833333333333 +lat_2=32.7833333333333 +x_0=2000000 +y_0=500000 +ellps=GRS80 +datum=NAD83 +units=m +no_defs +type=crs" },
  { code: "EPSG:2225", name: "NAD83 / California zone 1 (ftUS)", proj4: "+proj=lcc +lat_0=39.3333333333333 +lon_0=-122 +lat_1=40 +lat_2=41.6666666666667 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +datum=NAD83 +units=us-ft +no_defs +type=crs" },
  { code: "EPSG:2226", name: "NAD83 / California zone 2 (ftUS)", proj4: "+proj=lcc +lat_0=37.6666666666667 +lon_0=-122 +lat_1=38.3333333333333 +lat_2=39.8333333333333 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +datum=NAD83 +units=us-ft +no_defs +type=crs" },
  { code: "EPSG:2227", name: "NAD83 / California zone 3 (ftUS)", proj4: "+proj=lcc +lat_0=36.5 +lon_0=-120.5 +lat_1=37.0666666666667 +lat_2=38.4333333333333 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +datum=NAD83 +units=us-ft +no_defs +type=crs" },
  { code: "EPSG:6420", name: "NAD83(2011) / California zone 3 (ftUS)", proj4: "+proj=lcc +lat_0=36.5 +lon_0=-120.5 +lat_1=37.0666666666667 +lat_2=38.4333333333333 +x_0=6561666.667 +y_0=1640416.667 +ellps=GRS80 +units=us-ft +no_defs +type=crs" },
  { code: "EPSG:2228", name: "NAD83 / California zone 4 (ftUS)", proj4: "+proj=lcc +lat_0=35.3333333333333 +lon_0=-119 +lat_1=36 +lat_2=37.25 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +datum=NAD83 +units=us-ft +no_defs +type=crs" },
  { code: "EPSG:2229", name: "NAD83 / California zone 5 (ftUS)", proj4: "+proj=lcc +lat_0=34 +lon_0=-118 +lat_1=34.0333333333333 +lat_2=35.4666666666667 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +datum=NAD83 +units=us-ft +no_defs +type=crs" },
  { code: "EPSG:2230", name: "NAD83 / California zone 6 (ftUS)", proj4: "+proj=lcc +lat_0=32.1666666666667 +lon_0=-116.25 +lat_1=33.8833333333333 +lat_2=32.7833333333333 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +datum=NAD83 +units=us-ft +no_defs +type=crs" },
  { code: "EPSG:2236", name: "NAD83 / Florida East (ftUS)", proj4: "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-81 +k=0.999941177 +x_0=200000.0001016 +y_0=0 +ellps=GRS80 +datum=NAD83 +units=us-ft +no_defs +type=crs" },
  { code: "EPSG:2237", name: "NAD83 / Florida West (ftUS)", proj4: "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-82 +k=0.999941177 +x_0=200000.0001016 +y_0=0 +ellps=GRS80 +datum=NAD83 +units=us-ft +no_defs +type=crs" },
  { code: "EPSG:2238", name: "NAD83 / Florida North (ftUS)", proj4: "+proj=lcc +lat_1=30.75 +lat_2=29.5833333333333 +lat_0=29 +lon_0=-84.5 +x_0=600000 +y_0=0 +ellps=GRS80 +datum=NAD83 +units=us-ft +no_defs +type=crs" },
  // Washington
  { code: "EPSG:2285", name: "NAD83 / Washington North (ftUS)", proj4: "+proj=lcc +lat_0=47 +lon_0=-120.833333333333 +lat_1=48.7333333333333 +lat_2=47.5 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +datum=NAD83 +units=us-ft +no_defs +type=crs" },
  { code: "EPSG:2286", name: "NAD83 / Washington South (ftUS)", proj4: "+proj=lcc +lat_0=45.3333333333333 +lon_0=-120.5 +lat_1=47.3333333333333 +lat_2=45.8333333333333 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +datum=NAD83 +units=us-ft +no_defs +type=crs" },
  // Texas
  { code: "EPSG:2276", name: "NAD83 / Texas North (ftUS)", proj4: "+proj=lcc +lat_0=34 +lon_0=-101.5 +lat_1=36.1833333333333 +lat_2=34.65 +x_0=200000.0001016 +y_0=1000000.0001016 +ellps=GRS80 +datum=NAD83 +units=us-ft +no_defs +type=crs" },
  { code: "EPSG:2277", name: "NAD83 / Texas North Central (ftUS)", proj4: "+proj=lcc +lat_0=31.6666666666667 +lon_0=-98.5 +lat_1=33.9666666666667 +lat_2=32.1333333333333 +x_0=600000 +y_0=2000000.0001016 +ellps=GRS80 +datum=NAD83 +units=us-ft +no_defs +type=crs" },
  { code: "EPSG:2278", name: "NAD83 / Texas Central (ftUS)", proj4: "+proj=lcc +lat_0=29.6666666666667 +lon_0=-100.333333333333 +lat_1=31.8833333333333 +lat_2=30.1166666666667 +x_0=700000 +y_0=3000000 +ellps=GRS80 +datum=NAD83 +units=us-ft +no_defs +type=crs" },
  { code: "EPSG:2279", name: "NAD83 / Texas South Central (ftUS)", proj4: "+proj=lcc +lat_0=27.8333333333333 +lon_0=-99 +lat_1=30.2833333333333 +lat_2=28.3833333333333 +x_0=600000 +y_0=4000000 +ellps=GRS80 +datum=NAD83 +units=us-ft +no_defs +type=crs" },
  { code: "EPSG:2280", name: "NAD83 / Texas South (ftUS)", proj4: "+proj=lcc +lat_0=25.6666666666667 +lon_0=-98.5 +lat_1=27.8333333333333 +lat_2=26.1666666666667 +x_0=300000 +y_0=5000000 +ellps=GRS80 +datum=NAD83 +units=us-ft +no_defs +type=crs" },
  // Louisiana
  { code: "EPSG:3452", name: "NAD83 / Louisiana North (ftUS)", proj4: "+proj=lcc +lat_0=30.5 +lon_0=-92.5 +lat_1=32.6666666666667 +lat_2=31.1666666666667 +x_0=999999.9999898 +y_0=0 +ellps=GRS80 +datum=NAD83 +units=us-ft +no_defs +type=crs" },
  { code: "EPSG:3454", name: "NAD83 / Louisiana South (ftUS)", proj4: "+proj=lcc +lat_0=28.5 +lon_0=-91.3333333333333 +lat_1=30.7 +lat_2=29.3 +x_0=999999.9999898 +y_0=0 +ellps=GRS80 +datum=NAD83 +units=us-ft +no_defs +type=crs" },
  // Mississippi
  { code: "EPSG:2255", name: "NAD83 / Mississippi East (ftUS)", proj4: "+proj=tmerc +lat_0=29.5 +lon_0=-88.8333333333333 +k=0.99995 +x_0=300000 +y_0=0 +ellps=GRS80 +datum=NAD83 +units=us-ft +no_defs +type=crs" },
  { code: "EPSG:2256", name: "NAD83 / Mississippi West (ftUS)", proj4: "+proj=tmerc +lat_0=29.5 +lon_0=-90.3333333333333 +k=0.99995 +x_0=700000 +y_0=0 +ellps=GRS80 +datum=NAD83 +units=us-ft +no_defs +type=crs" },
  // Alabama
  { code: "EPSG:2253", name: "NAD83 / Alabama East (ftUS)", proj4: "+proj=tmerc +lat_0=30 +lon_0=-85.8333333333333 +k=0.99996 +x_0=200000 +y_0=0 +ellps=GRS80 +datum=NAD83 +units=us-ft +no_defs +type=crs" },
  { code: "EPSG:2254", name: "NAD83 / Alabama West (ftUS)", proj4: "+proj=tmerc +lat_0=30 +lon_0=-87.5 +k=0.999933333 +x_0=600000 +y_0=0 +ellps=GRS80 +datum=NAD83 +units=us-ft +no_defs +type=crs" },
  // Georgia
  { code: "EPSG:2239", name: "NAD83 / Georgia East (ftUS)", proj4: "+proj=tmerc +lat_0=30 +lon_0=-82.1666666666667 +k=0.9999 +x_0=200000.0001016 +y_0=0 +ellps=GRS80 +datum=NAD83 +units=us-ft +no_defs +type=crs" },
  { code: "EPSG:2240", name: "NAD83 / Georgia West (ftUS)", proj4: "+proj=tmerc +lat_0=30 +lon_0=-84.1666666666667 +k=0.9999 +x_0=700000 +y_0=0 +ellps=GRS80 +datum=NAD83 +units=us-ft +no_defs +type=crs" },
  // North Carolina
  { code: "EPSG:2264", name: "NAD83 / North Carolina (ftUS)", proj4: "+proj=lcc +lat_0=33.75 +lon_0=-79 +lat_1=36.1666666666667 +lat_2=34.3333333333333 +x_0=609601.219202 +y_0=0 +ellps=GRS80 +datum=NAD83 +units=us-ft +no_defs +type=crs" },
  // Virginia
  { code: "EPSG:2283", name: "NAD83 / Virginia North (ftUS)", proj4: "+proj=lcc +lat_0=37.6666666666667 +lon_0=-78.5 +lat_1=39.2 +lat_2=38.0333333333333 +x_0=3500000 +y_0=2000000 +ellps=GRS80 +datum=NAD83 +units=us-ft +no_defs +type=crs" },
  { code: "EPSG:2284", name: "NAD83 / Virginia South (ftUS)", proj4: "+proj=lcc +lat_0=36.3333333333333 +lon_0=-78.5 +lat_1=37.9666666666667 +lat_2=36.7666666666667 +x_0=3500000 +y_0=1000000 +ellps=GRS80 +datum=NAD83 +units=us-ft +no_defs +type=crs" },
  // Maryland / Delaware
  { code: "EPSG:2248", name: "NAD83 / Maryland (ftUS)", proj4: "+proj=lcc +lat_0=37.6666666666667 +lon_0=-77 +lat_1=39.45 +lat_2=38.3 +x_0=400000 +y_0=0 +ellps=GRS80 +datum=NAD83 +units=us-ft +no_defs +type=crs" },
  { code: "EPSG:2235", name: "NAD83 / Delaware (ftUS)", proj4: "+proj=tmerc +lat_0=38 +lon_0=-75.4166666666667 +k=0.999995 +x_0=200000 +y_0=0 +ellps=GRS80 +datum=NAD83 +units=us-ft +no_defs +type=crs" },
  // New Jersey
  { code: "EPSG:3424", name: "NAD83 / New Jersey (ftUS)", proj4: "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +datum=NAD83 +units=us-ft +no_defs +type=crs" },
  // New York
  { code: "EPSG:2260", name: "NAD83 / New York East (ftUS)", proj4: "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.5 +k=0.9999 +x_0=150000.0001016 +y_0=0 +ellps=GRS80 +datum=NAD83 +units=us-ft +no_defs +type=crs" },
  { code: "EPSG:2261", name: "NAD83 / New York Central (ftUS)", proj4: "+proj=tmerc +lat_0=40 +lon_0=-76.5833333333333 +k=0.9999375 +x_0=250000 +y_0=0 +ellps=GRS80 +datum=NAD83 +units=us-ft +no_defs +type=crs" },
  { code: "EPSG:2262", name: "NAD83 / New York West (ftUS)", proj4: "+proj=tmerc +lat_0=40 +lon_0=-78.5833333333333 +k=0.9999375 +x_0=350000 +y_0=0 +ellps=GRS80 +datum=NAD83 +units=us-ft +no_defs +type=crs" },
  { code: "EPSG:2263", name: "NAD83 / New York Long Island (ftUS)", proj4: "+proj=lcc +lat_0=40.1666666666667 +lon_0=-74 +lat_1=41.0333333333333 +lat_2=40.6666666666667 +x_0=300000 +y_0=0 +ellps=GRS80 +datum=NAD83 +units=us-ft +no_defs +type=crs" },
];

const DEFAULT_PROFILE = {
  name: "Default Hydro Profile",
  horizontalCRS: "EPSG:4326",
  verticalDatum: "MSL",
  geoidModel: "None",
  linearUnits: "meters",
  angularUnits: "degrees",
};

function normalizeCode(code) {
  return String(code || "").trim().toUpperCase();
}

function isFiniteCoord(v) {
  return Number.isFinite(Number(v));
}

function clone(obj) {
  return JSON.parse(JSON.stringify(obj));
}

export function createProjectionService({ events }) {
  const customCRS = new Map();
  let profile = { ...DEFAULT_PROFILE };

  function persistProfile() {
    localStorage.setItem(PROFILE_KEY, JSON.stringify(profile));
  }

  function persistCustomCRS() {
    const arr = [...customCRS.values()];
    localStorage.setItem(CUSTOM_CRS_KEY, JSON.stringify(arr));
  }

  function loadProfile() {
    try {
      const raw = localStorage.getItem(PROFILE_KEY);
      if (!raw) return;
      const parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== "object") return;
      profile = { ...DEFAULT_PROFILE, ...parsed };
    } catch (err) {
      console.error("[Projections] profile load failed", err);
    }
  }

  function loadCustomCRS() {
    try {
      const raw = localStorage.getItem(CUSTOM_CRS_KEY);
      if (!raw) return;
      const parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return;
      for (const def of parsed) {
        if (!def || typeof def !== "object") continue;
        const code = normalizeCode(def.code);
        const proj = String(def.proj4 || "").trim();
        const name = String(def.name || code).trim();
        if (!code || !proj) continue;
        proj4.defs(code, proj);
        customCRS.set(code, { code, name, proj4: proj });
      }
    } catch (err) {
      console.error("[Projections] custom CRS load failed", err);
    }
  }

  function seedBuiltins() {
    for (const def of BUILTIN_CRS) {
      proj4.defs(def.code, def.proj4);
    }
  }

  function listCRS() {
    const all = [...BUILTIN_CRS, ...customCRS.values()];
    return all
      .slice()
      .sort((a, b) => a.code.localeCompare(b.code))
      .map((x) => ({ ...x }));
  }

  function getCRS(code) {
    const key = normalizeCode(code);
    return listCRS().find((x) => normalizeCode(x.code) === key) || null;
  }

  function registerCRS({ code, name, proj4: proj }) {
    const normalized = normalizeCode(code);
    const projStr = String(proj || "").trim();
    if (!normalized || !projStr) throw new Error("CRS code and proj4 are required");
    proj4.defs(normalized, projStr);
    customCRS.set(normalized, { code: normalized, name: String(name || normalized).trim(), proj4: projStr });
    persistCustomCRS();
    events.emit("projection:catalog:changed", { crs: listCRS() });
    return normalized;
  }

  function removeCustomCRS(code) {
    const normalized = normalizeCode(code);
    const removed = customCRS.delete(normalized);
    if (!removed) return false;
    persistCustomCRS();
    events.emit("projection:catalog:changed", { crs: listCRS() });
    return true;
  }

  function getProjectProfile() {
    return { ...profile };
  }

  function setProjectProfile(next) {
    profile = { ...profile, ...(next || {}) };
    persistProfile();
    events.emit("projection:profile:changed", { profile: getProjectProfile() });
    return getProjectProfile();
  }

  function resetProjectProfile() {
    profile = { ...DEFAULT_PROFILE };
    persistProfile();
    events.emit("projection:profile:changed", { profile: getProjectProfile() });
    return getProjectProfile();
  }

  function resolveDef(input) {
    if (typeof input === "string") {
      const trimmed = input.trim();
      if (!trimmed) throw new Error("Missing CRS");
      if (trimmed.includes("+proj=")) return trimmed;
      return normalizeCode(trimmed);
    }
    if (input && typeof input === "object") {
      if (input.proj4) return String(input.proj4).trim();
      if (input.code) return normalizeCode(input.code);
    }
    throw new Error("Invalid CRS");
  }

  function transformCoord(coord, fromCRS, toCRS) {
    if (!Array.isArray(coord) || coord.length < 2) throw new Error("Coordinate must be [x,y]");
    if (!isFiniteCoord(coord[0]) || !isFiniteCoord(coord[1])) throw new Error("Coordinate must be numeric");
    const from = resolveDef(fromCRS);
    const to = resolveDef(toCRS);
    if (from === to) return coord.slice();
    const [x, y] = proj4(from, to, [Number(coord[0]), Number(coord[1])]);
    if (coord.length > 2) return [x, y, coord[2]];
    return [x, y];
  }

  function transformGeometry(geometry, fromCRS, toCRS) {
    if (!geometry || typeof geometry !== "object") return geometry;
    const g = clone(geometry);
    const xformPos = (pos) => transformCoord(pos, fromCRS, toCRS);

    function walkCoords(node) {
      if (!Array.isArray(node)) return node;
      if (node.length >= 2 && isFiniteCoord(node[0]) && isFiniteCoord(node[1])) return xformPos(node);
      return node.map((child) => walkCoords(child));
    }

    if (g.type === "GeometryCollection" && Array.isArray(g.geometries)) {
      g.geometries = g.geometries.map((child) => transformGeometry(child, fromCRS, toCRS));
      return g;
    }

    g.coordinates = walkCoords(g.coordinates);
    return g;
  }

  function transformFeatureCollection(fc, fromCRS, toCRS) {
    if (!fc || fc.type !== "FeatureCollection" || !Array.isArray(fc.features)) {
      throw new Error("Expected GeoJSON FeatureCollection");
    }
    const out = clone(fc);
    out.features = out.features.map((f) => ({
      ...f,
      geometry: transformGeometry(f.geometry, fromCRS, toCRS),
    }));
    return out;
  }

  seedBuiltins();
  loadCustomCRS();
  loadProfile();

  return {
    listCRS,
    getCRS,
    registerCRS,
    removeCustomCRS,
    getProjectProfile,
    setProjectProfile,
    resetProjectProfile,
    transformCoord,
    transformGeometry,
    transformFeatureCollection,
  };
}
